import { Select } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Analytics.module.scss';
import { useAppSelector } from 'store/hook';
import AllAnalytics from 'components/AllAnalytics/AllAnalytics';

const periods = ['today','week','month','year'];

const Analytics = () => {
  const { t, i18n } = useTranslation();
  const [availablePeriods, setAvailablePeriods] = React.useState<any[]>([]);
  const [choosenPeriod, setChoosenPeriod] = React.useState('week');

  const [availableCases, setAvailableCases] = React.useState<any[]>([]);
  const [choosenRoom, setChoosenRoom] = React.useState('all');

  const { available_rooms, userData } = useAppSelector((state) => state.userData);

  React.useEffect(() => {
    available_rooms && available_rooms[0] ? setAvailableCases([
      { value: 'all', key: 'all', label: t('Analytics.allRooms') },
      ...available_rooms?.filter(room => room.owner_id === userData?.id)
        .map(room => ({
          value: room.id,
          key: room.id,
          label: room.name,
        }))
    ]) : setAvailableCases([{ value: 'all', key: 'all', label: t('Analytics.allRooms') }])
  }, [available_rooms, i18n.language]);

  React.useEffect(() => {
    setAvailablePeriods([
      ...periods?.map(period => ({
        value: period,
        key: period,
        label: t(`Analytics.periods.${period}`),
      }))
    ]);
  }, [i18n.language]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.mainTitle}>
        <div className={classes.title}>{t('Analytics.title')}</div>

        <div>
          <Select
            options={availableCases}
            popupMatchSelectWidth={false}
            value={choosenRoom}
            onChange={setChoosenRoom}
          />
          
        </div>
      </div>

      <AllAnalytics
        choosenRoom={choosenRoom}
        choosenPeriod={choosenPeriod}
        setChoosenPeriod={setChoosenPeriod}
        availablePeriods={availablePeriods}
      />
    </div>
  );
}

export default Analytics;
